export default {
  computed: {
    isIOS () {
      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return true
      return false
    },
  },
}
